/**
 * 落地页车型匹配
 * */

$(document).ready(function (e) {
  // 是否显示筛选器
  myAjax({
    url: "api/shopify/vehicle/display",
    data: { product_id: `${productid}~` },
  }).then((res) => {
    if (res.data.display) {
      InitSelectVehicleForProductDetail({
        productId: productid,
        fromDetailPage: true,
      });
    }else {
        document.querySelector('.selectcar-title').style='display:none';
        document.querySelector('#selectcarJs').style='display:none';
        document.querySelector('.before-add-to-cart-note').style='display:none';
        /*document.querySelector('#selectcarJs').innerHTML=`<div style="padding: 6px;">
        <div style="color: red;font-size: 1rem;">Universal Fit! Please Measure whether Your Car Size is Suitable!</div>`*/
    }
  });
});
